import { GetDeviceSnapshotDTO } from '@eppendorf/vnls-device-service-utils';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';

import {
  isCentrifugeLarge,
  resolveSetPointValue,
} from '$features/monitoring/shared/centrifuge-large.utils';

interface CentrifugeLargeRotorInfoProps {
  snapshot?: GetDeviceSnapshotDTO;
}

/**
 * Displays the rotor information for centrifuge-large devices (SpinPro 6 R / SpinPro 8 R)
 * in the sidecar header area, inline with the device status badges.
 */
export function CentrifugeLargeRotorInfo({ snapshot }: CentrifugeLargeRotorInfoProps) {
  if (!snapshot || !isCentrifugeLarge(snapshot.inventoryDevice)) {
    return null;
  }

  const rotorComponent = snapshot.currentShadow?.components?.find(
    (c) => c.id === 'Rotor',
  );

  const rotorSetPoint = resolveSetPointValue(rotorComponent?.setPoint);
  if (!rotorSetPoint) {
    return null;
  }

  return (
    <div className="flex flex__ai--center gap-s" data-testid="centrifuge-rotor-info">
      <Icon name="rotor" size={IconSizeClasses.XSmall} />
      <span className="font-size-s">{rotorSetPoint}</span>
    </div>
  );
}
